export const TERMS_OF_USE_HTML = `
<div class="legal-section">
  <h3 class="ui-heading-4">Terms of Use</h3>
  <p>
    Welcome to the PDMA Capability Gap Assessment platform. By accessing or using this
    application, you agree to be bound by these Terms of Use.
  </p>
</div>

<div class="legal-section">
  <h3 class="ui-heading-4">1. Purpose</h3>
  <p>
    This platform is provided by Roche for internal use only. It is designed to support
    professional development by assessing competency levels across PDMA capability areas
    using situational judgment scenarios.
  </p>
</div>

<div class="legal-section">
  <h3 class="ui-heading-4">2. Acceptable Use</h3>
  <p>
    You agree to use this platform solely for its intended purpose of capability assessment
    and professional development. You may not share your login credentials or attempt to
    access another user's assessment data.
  </p>
</div>

<div class="legal-section">
  <h3 class="ui-heading-4">3. Data Handling</h3>
  <p>
    Assessment responses are stored securely and used to generate individual and aggregated
    reports. Individual scores are visible only to the assessed user. Aggregated data may be
    shared with team leads when a minimum anonymity threshold is met.
  </p>
</div>

<div class="legal-section">
  <h3 class="ui-heading-4">4. Disclaimer</h3>
  <p>
    This is a development version of the platform. These terms are provisional and subject
    to change. Final terms will be provided before production release.
  </p>
</div>
`;

export const PRIVACY_NOTICE_HTML = `
<div class="legal-section">
  <h3 class="ui-heading-4">Privacy Notice</h3>
  <p>
    This Privacy Notice explains how the PDMA Capability Gap Assessment platform collects,
    uses, and protects your personal data.
  </p>
</div>

<div class="legal-section">
  <h3 class="ui-heading-4">1. Data Collected</h3>
  <p>
    We collect your name, email address (via Google SSO), and your assessment responses.
    No sensitive personal data beyond what is necessary for the assessment is collected.
  </p>
</div>

<div class="legal-section">
  <h3 class="ui-heading-4">2. Purpose of Processing</h3>
  <p>
    Your data is processed to provide capability assessment results, generate development
    recommendations, and produce aggregated team-level reports.
  </p>
</div>

<div class="legal-section">
  <h3 class="ui-heading-4">3. Data Retention</h3>
  <p>
    Assessment data is retained for the duration of your employment or until you request
    deletion. Aggregated, anonymized data may be retained for trend analysis.
  </p>
</div>

<div class="legal-section">
  <h3 class="ui-heading-4">4. Your Rights</h3>
  <p>
    You have the right to access, correct, or request deletion of your personal data.
    Contact the support team for any data-related requests.
  </p>
</div>

<div class="legal-section">
  <h3 class="ui-heading-4">5. Disclaimer</h3>
  <p>
    This is a development version of the platform. This privacy notice is provisional and
    subject to change. A final privacy notice will be provided before production release.
  </p>
</div>
`;

export const SUPPORT_HTML = `
<div class="legal-section">
  <h3 class="ui-heading-4">Support</h3>
  <p>
    If you experience any issues with the PDMA Capability Gap Assessment platform or have
    questions about the assessment process, please reach out to the technical contact below.
  </p>
</div>

<div class="legal-section">
  <h3 class="ui-heading-4">Technical Contact</h3>
  <p>
    <strong>Email:</strong>
    <a href="mailto:berk_adrian.greser@roche.com">berk_adrian.greser&#64;roche.com</a>
  </p>
</div>

<div class="legal-section">
  <h3 class="ui-heading-4">Common Issues</h3>
  <ul>
    <li>If you cannot sign in, ensure you are using your Roche Google account.</li>
    <li>If your assessment progress is not loading, try refreshing the page.</li>
    <li>For team assignment issues, contact your team lead or the technical contact above.</li>
  </ul>
</div>
`;
